import { FeatureFlag } from '@swf/core/enums';
import type { Feature } from '@swf/core/models/feature';
import type { EffectParams } from '@swf/core/store';

const check = async (payload: undefined, { dispatch, request }: EffectParams) => {
  const { body } = await request<Feature>({
    service: 'features.check',
    body: { features: Object.values(FeatureFlag) }
  });
  dispatch.feature.update(body);
};

export default check;
